import React, { Component } from 'react';

import { Icon } from 'elements';
import {
  classnames,
  classname
} from 'utils';

import './Counter.css';

class Counter extends Component {
  cl = classname('counter');

  constructor(props) {
    super(props);

    let i = 0;
    let time = 1;

    const { children } = props;
    this.valueProp = Math.round(Number(children) * 10) / 10;

    this.state = {
      value: 0,
      diagramValue: '0 300'
    };

    this.count = () => {
      console.group();
      console.log('value', this.props.children);
      console.log('valueProp', Math.round(Number(this.valueProp) * 10) / 10);
      console.groupEnd();

      let step = ((time / this.valueProp) * 1000) / 10;

      this.interval = setInterval(() => {
        i = Math.round(Number(i + .1) * 10) / 10;

        this.setState({
          value: i
        }, () => {
          if (i >= this.valueProp) clearInterval(this.interval);
        });
      }, step);
    };

    this.daigramMove = () => {
      let newValue = this.valueProp * 10 * 1.2; // Умножаю не на 1.25, а на 1.2 чтобы при 9.9 оставался небольшой зазор

      setTimeout(() => {
        this.setState({
          diagramValue: `${newValue} 300`
        });
      }, 50);
    };
  }

  componentDidMount() {
    if (this.valueProp) {
      this.count();
      this.daigramMove();
    }
  }

  // Очищаем таймер, после того, как элемент удален со страницы
  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const { className, align } = this.props;

    const classes = classnames(className, this.cl({ align }));

    return (
      <div className={classes}>
        {
          this.valueProp ? (
            <>
              <div className={this.cl('diagram-wrapper')}>
                <svg viewBox="0 0 48 48" className={this.cl('diagram')}>
                  <circle
                    className={this.cl('diagram-all')}
                    cx="24"
                    cy="24"
                    r="20"
                    strokeWidth="8"
                    fill="none"
                    transform="rotate(-90, 24, 24)"
                  />
                  <circle
                    className={this.cl('diagram-current')}
                    cx="24"
                    cy="24"
                    r="20"
                    strokeWidth="8"
                    fill="none"
                    transform="rotate(-90, 24, 24)"
                    strokeDasharray={this.state.diagramValue}
                  />
                </svg>
              </div>

              <div className={this.cl('value')}>
                {new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 1 }).format(this.state.value)}
              </div>
            </>
          ) : (
            <Icon name={'star'} className={this.cl('star')}/>
          )
        }
      </div>
    );
  }
}

export default Counter;
